import React from 'react';
import { useNavigate } from 'react-router-dom';

const CartSummary = ({ subtotal = 0, tax = 0, shipping = 0, isDisabled = false }) => {
  const navigate = useNavigate();
  const total = subtotal + tax + shipping;
  const formatCurrency = (value) => `€${value.toFixed(2)}`;
  
  const handleCheckout = () => {
    if (isDisabled) {
      return;
    }
    navigate('/checkout');
  };

  const handleReturnToShop = () => {
    navigate('/products');
  };
  return (
    <div className="bg-gray-50 p-6 rounded-2xl shadow-sm border border-gray-100">
      <h2 className="text-lg font-medium mb-4">Order Summary</h2>
      
      <div className="space-y-2 mb-4">
        <div className="flex justify-between">
          <span className="text-gray-600">Subtotal</span>
          <span className="font-medium">{formatCurrency(subtotal)}</span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-gray-600">Tax</span>
          <span className="font-medium">{formatCurrency(tax)}</span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-gray-600">Shipping</span>
          <span className="font-medium">{formatCurrency(shipping)}</span>
        </div>
      </div>
      
      <div className="border-t border-gray-200 pt-4 mb-6">
        <div className="flex justify-between font-medium">
          <span>Total</span>
          <span>{formatCurrency(total)}</span>
        </div>
      </div>
      
      <div className="space-y-2">
        <button
          className="w-full bg-black text-white p-3 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={handleCheckout}
          disabled={isDisabled}
        >
          Paguaj
        </button>
        <button
          className="w-full border border-gray-300 py-3"
          onClick={handleReturnToShop}
        >
          Return to Shop
        </button>
      </div>
    </div>
  );
};

export default CartSummary;